// eslint-disable-next-line import/prefer-default-export
import { Quill } from 'react-quill';

export const fontsList = [false, 'Georgia', 'Arial', 'Montserrat', 'Rubik', 'Bradley Hand', 'Courier'];
// To add more fonts:
// 1. Append new value in the list above
// 2. Go to ~/src/components/Quill/index.jsx
// 3. Append css-styles inside 'styles' variable for new font according to how it's been done before.

export const sizesList = ['10px', false, 'large', '32px'];
// WARNING After changing any values here make sure these steps also were made:
// 1. Go to ~/src/components/Quill/index.jsx
// 2. Change styles inside '& .ql-picker.ql-size' accordingly

export const defaultToolbarModules = {
  imageResize: {
    parchment: Quill.import('parchment'),
    modules: ['Resize', 'DisplaySize'],
  },
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ size: sizesList }, { font: fontsList }],
    [{ color: [] }, { align: ['', 'center', 'right', 'justify'] }],
    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
    ['image', 'link', 'emoji'],
    ['clean'],
  ],
  'emoji-toolbar': true,
  'emoji-shortname': true,
};

export const inboxToolbarModules = {
  imageResize: {
    parchment: Quill.import('parchment'),
    modules: ['Resize', 'DisplaySize'],
  },
  toolbar: [
    ['bold', 'italic', 'underline', 'strike',
      { size: sizesList }, { font: fontsList },
      { color: [] }, { align: ['', 'center', 'right', 'justify'] },
      { list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' },
      'image', 'link', 'emoji',
      'clean'],
  ],
  'emoji-toolbar': true,
  'emoji-shortname': true,
};

export const signatureToolbarModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike',
      { size: sizesList }, { font: fontsList },
      { color: [] }, { align: ['', 'center', 'right', 'justify'] },
      { list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' },
      'link', 'emoji',
      'clean'],
  ],
  'emoji-toolbar': true,
  'emoji-shortname': true,
};

export const SUBJECT_INHERITED = 'Subject inherited';
